module.exports = __webpack_public_path__ + "img/history.83dfa365.svg";